module.exports = __webpack_public_path__ + "static/img/reward.70edabe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reward.png
// module id = nLdQ
// module chunks = 1